(function () {
  const CART_ATTRIBUTE_KEY = 'active_promo';
  const PERSISTENT_STORAGE_KEY = 'promo_outlet_access_persistent';

  const currentUrl = new URL(window.location.href);
  const promoFromUrl = currentUrl.searchParams.get('promo');

  // 1. Rimuove immediatamente il parametro dall'URL del browser (silenzioso)
  currentUrl.searchParams.delete('promo');
  const cleanUrl = currentUrl.pathname + (currentUrl.search ? currentUrl.search : '');

  const updateCartAndDom = (promoValue) => {
    return fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [CART_ATTRIBUTE_KEY]: promoValue || '', menu_view: '' } }),
    })
    .then(res => {
      if (!res.ok) throw new Error('Cart update error');
      // Richiede la pagina aggiornata con il carrello appena autorizzato
      return fetch(cleanUrl, { cache: 'no-cache' });
    })
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // A. Aggiorna il contenuto principale se era protetto (MainContent)
      const newMain = doc.getElementById('MainContent');
      const oldMain = document.getElementById('MainContent');
      if (newMain && oldMain) {
        oldMain.innerHTML = newMain.innerHTML;
      }

      // B. Aggiorna l'header (menu e switcher Outlet/Atelier)
      const newHeader = doc.querySelector('#shopify-section-header, .header-wrapper, header');
      const oldHeader = document.querySelector('#shopify-section-header, .header-wrapper, header');
      if (newHeader && oldHeader) {
        oldHeader.replaceWith(newHeader);
      }
    })
    .catch(err => {
      console.error('Silenced promo update fallback:', err);
      window.location.replace(cleanUrl);
    });
  };

  // Se l'utente arriva con ?promo=
  if (promoFromUrl) {
    // Pulisce visivamente l'URL nella barra degli indirizzi
    window.history.replaceState({}, document.title, cleanUrl);
    localStorage.setItem(PERSISTENT_STORAGE_KEY, promoFromUrl);

    // Esegue tutto in background senza ricaricare la finestra
    updateCartAndDom(promoFromUrl);
    return;
  }

  // Se la promo è scaduta/disattivata secondo Liquid
  if (window.PROMO_INVALID_OR_EXPIRED) {
    localStorage.removeItem(PERSISTENT_STORAGE_KEY);
    fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [CART_ATTRIBUTE_KEY]: '', menu_view: '' } }),
    }).catch(err => console.error(err));
  }
})();
